

export const BASE_URL = "https://api.indiahirings.com"
// export const BASE_URL = "https://api.indiahirings.com"
export const ADMIN_AUTH = "Bearer 1|qzdKsGqCl4x2vKH2c2b4Qt1Exn6KcIf5QkswXJoH90ca7775"

export const EMPLOYER_COMPANY_LOGO_SAVE_URL = "https://api.indiahirings.com/uploads/company/"
export const RESUME_VIEW = "https://api.indiahirings.com/uploads/candidate/resume/"
export const INTERVIEW_PREPARATION_VIEW = "https://api.indiahirings.com/uploads/interview_preparation/"
export const SKILL_DEVELOPMENT_VIEW = "https://api.indiahirings.com/uploads/skill_development/"
export const CAREER_ADVICE_VIEW = "https://api.indiahirings.com/uploads/career_advice/"
export const CANDIDATE_PROFILE = "https://api.indiahirings.com/uploads/candidate/profile/";

// Payment Gateway
export const PAYMENT_GATEWAY = "https://api.indiahirings.com/candidate/candidate-subscriptions-payment";
export const RAZOR_PAY_KEY = "rzp_test_bcjMYLCrJyB435";

export const GMAIL_REGISTER = "https://api.indiahirings.com/api/auth/login-google"
export const REGISTER = "https://api.indiahirings.com/api/auth/register"
export const LOGIN = "https://api.indiahirings.com/api/auth/login"
export const LOGOUT = "https://api.indiahirings.com/api/auth/logout"

// Admin URLs
export const ADMIN = "admin"
export const ADMIN_PRODUCT_REVIEW = "product-reviews"
export const ADMIN_REVIEWS = "company-reviews"
export const DASHBOARD_DATA = "dashboard"
export const CONTACT_US = "sales-contact-us"
export const ADMIN_NOTIFICATIONS = "admin-notifications"
export const USER_SEARCH = "get-user-data"
export const ADMIN_RESUME_BUILDER = "resume-builders"
export const SUBSCRIPTION_MANUAL = "https://api.indiahirings.com/admin/subscriptions-manuual-employer";
export const SUBSCRIPTIONS = "https://api.indiahirings.com/admin/subscriptions";
export const SUBSCRIPTIONS_TOPUP = "https://api.indiahirings.com/admin/subscriptions-topup-employer";
export const SUBSCRIPTIONS_TOPUP_EMPLOYER = "https://api.indiahirings.com/admin/subscriptions-topup";
export const SUBSCRIPTION_DETAILS_EMPLOYER = "https://api.indiahirings.com/admin/subscriptions-details-employer"
export const SKILL_DEVELOPMENT = "skill-development"
export const INTERVIEW_PREPARATION = "interview-preparation"
export const CAREER_ADVICE_ADMIN = "career-advice"

export const JOBS = "jobs"

export const EMPLOYER = "employer"
export const EMPLOYER_DATA = "employer-data"
export const EMPLOYER_PROFILE_VERIFIED = "employer-profile-verified"
export const EMPLOYER_SUBSCRIPTIONS = "employer-subscriptions"
export const EMPLOYER_SUBSCRIPTIONS_HISTORY = "employer-subscriptions-history"
export const EMPLOYER_SUBSCRIPTIONS_PAYMENT = "employer-subscriptions-payment"
export const APPLICANTS = "applicants"
export const EMPLOYER_COMPANY_LOGO = "employer-company-logo"
export const EMPLOYER_COMPANY_PROFILE = "employer-company-profile"
export const EMPLOYER_APPLIED_CANDIDATES = "candidate-job-apply"
export const EMPLOYER_SEARCHED_CANDIDATES = "search-candidate"
export const EMPLOYER_APPLICANT_INTERVIEW_SCHEDULED = "applicant-interview-schedule"

export const CORE = "core"
export const CITY = "city"
export const STATE = "state"
export const COUNTRY = "country"
export const CORE_LOCATIONS = "fetch-core-location"
export const CORE_EDUCATIONS = "fetch-core-educations"
export const CORE_SKILLS = "fetch-core-skills"
export const CORE_INDUSTRY = "core-industry"
export const CORE_CITY = "core-job-city"
export const CORE_JOB_COMPANY = "core-job-company"
export const CORE_JOB_DEPARTMENTS = "core-job-departments"
export const CORE_JOB_SKILLS = "core-job-skills"
export const CORE_JOB_TITLES = "core-job-title"
export const CORE_JOB_EDUCATIONS = "core-job-educations"
export const CORE_JOB_EDUCATION_COURSE = "core-job-education-course"
export const CORE_JOB_EDUCATION_COURSE_SPECIALTY = "core-job-course-specialty"

export const CANDIDATE = "candidate"

export const CANDIDATE_SUBSCRIPTIONS = "candidate-subscriptions"
export const CANDIDATE_SUBSCRIPTIONS_HISTORY = "candidate-subscriptions-history"
export const CANDIDATE_SUBSCRIPTIONS_ACTIVE = "candidate-active-subscriptions"
export const CANDIDATE_SUBSCRIPTIONS_PAYMENT = "candidate-subscriptions-payment"
export const CANDIDATE_DATA = "candidate-data"
export const CANDIDATE_PROFILE_VERIFIED = "candidate-profile-verified"
export const PUBLIC_TITLES = "fetch-core-titles"
export const PUBLIC_SKILLS = "fetch-core-skills"
export const CANDIDATE_RECOMMENDED_JOBS = "fetch-recommended-jobs"
export const CANDIDATE_MOST_ACTIVE_RECENT_JOBS = "candidate-most-active-recent-jobs"
export const CANDIDATE_SEARCH_HISTORY = "candidate-search-history"
export const CANDIDATE_CAREER_PROFILE = "fetch-candidate-career-profile"
export const CANDIDATE_JOB_APPLY = "candidate-job-apply"
export const CANDIDATE_JOB_SAVED = "candidate-job-saved"
export const CANDIDATE_JOB_SEARCH = "fetch-jobs-list"
export const CANDIDATE_KEYWORD_SUGGESTION = "get-title-skill-company-list"
export const RELATED_JOBS = "https://api.indiahirings.com/api/jobs-by-skills"
export const SKILL_DEVELOPMENT_CANDIDATE = "candidate-skill-development"
export const INTERVIEW_PREPARATION_CANDIDATE = "candidate-interview-preparation"
export const CAREER_ADVICE_CANDIDATE = "candidate-career-advice"

export const CANDIDATE_DETAILS_BY_PARAM = "fetch-candidate"
export const CANDIDATE_BASIC_DETAILS_PARAM = "basic_details=1"
export const CANDIDATE_CERTIFICATION_PARAM = "certifications=1"
export const CANDIDATE_EDUCATION_PARAM = "education=1"
export const CANDIDATE_EMPLOYMENT_PARAM = "employment=1"
export const CANDIDATE_ITSKILLS_PARAM = "it_skills=1"
export const CANDIDATE_JOB_PREFERENCE_PARAM = "job_preference=1"
export const CANDIDATE_LANGUAGES_PARAM = "candidate_languages=1"
export const CANDIDATE_PROJECTS_PARAM = "projects=1"
export const CANDIDATE_CURRENT_COMPANY_PARAM = "current_company=1"

export const CANDIDATE_BASIC_DETAILS = "candidate-basic-details"
export const CANDIDATE_PROFILE_PHOTO = "candidate-basic-details-profile"
export const CANDIDATE_RESUME = "candidate-basic-details-resume"
export const CANDIDATE_ACTIVE_RESUME = "resume-builder-active"
export const CANDIDATE_RESUME_BUILDER = "resume-builder-candidate"
export const CANDIDATE_CERTIFICATIONS = "candidate-certifications"
export const CANDIDATE_EDUCATIONS = "candidate-educations"
export const CANDIDATE_EMPLOYMENT = "candidate-employment"
export const CANDIDATE_SKILLS = "candidate-it-skills"
export const CANDIDATE_JOB_PREFERENCE = "candidate-job-preference"
export const CANDIDATE_LANGUAGES = "candidate-languages"
export const CANDIDATE_PROJECTS = "candidate-projects"
export const COMPANY_REVIEW_SAVE = "company-review-save"

export const Media_View = "https://api.indiahirings.com/uploads/company/media/"

export const EMPLOYER_COMPANY_MEDIA_URL = "https://api.indiahirings.com/uploads/company/media/"
export const PUBLIC = "api"
export const COUNTRIES = "global-address-countries"
export const STATES = "global-address-states"
export const CITIES = "global-address-cities"
export const MOST_SEARCH_JOBS_DEPARTMENTS = "most-search-jobs-department"
export const PUBLIC_SUBSCRIPTION_CANDIDATE = "fetch-subscription-list/candidate"
export const POPULAR_JOB_ROLES = "popular-job-roles"
export const JOBS_BY_DEPARTMENTS = "jobs-by-category"
export const JOBS_BY_ROLES = "jobs-by-roles"
export const LATEST_JOBS = "most-active-recent-jobs"
export const TOP_COMPANIES = "most-active-jobs-company"
export const PUBLIC_JOBS = "jobs"
export const PUBLIC_CONTACT_US = "sales-contact-us"
export const PROFILE_VERIFICATION_EMAIL = "profile-verification/email"
export const PROFILE_VERIFICATION_PHONE = "profile-verification/phone"
export const PROFILE = "profile"

export const COMPANY_LIST = "fetch-company-list"
export const COMPANY_DETAILS = "fetch-company-details"
export const COMPANY_JOB_LIST = "fetch-company-job-list"
export const COMPANY_REVIEWS = "company-reviews"
export const COMPANY_REVIEW_LIST = "fetch-company-review-list"
export const PRODUCT_REVIEW_LIST = "product-reviews-list"
